import DetailsSample from './DetailsSample'

export default DetailsSample